import { createRoot } from "react-dom/client";
import { ImpactHero } from "@/app/components/impact/ImpactHero";
import { RealityCheck } from "@/app/components/impact/RealityCheck";
import { TransformationSplit } from "@/app/components/impact/TransformationSplit";
import { LiveMetrics } from "@/app/components/impact/LiveMetrics";
import { SuccessStories } from "@/app/components/impact/SuccessStories";
import { SystemVisualization } from "@/app/components/impact/SystemVisualization";
import { TransformationCTA } from "@/app/components/impact/TransformationCTA";
import { Navigation } from "@/app/components/Navigation";
import { Footer } from "@/app/components/Footer";
import "@/styles/index.css";

function ImpactPage() {
  return (
    <div className="relative bg-[#0B0E14] overflow-x-hidden">
      <Navigation />
      <ImpactHero />
      <RealityCheck />
      <TransformationSplit />
      <LiveMetrics />
      <SuccessStories />
      <SystemVisualization />
      <TransformationCTA />
      <Footer />
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<ImpactPage />);
